import type { ImageAsset } from "./images";

export type LuxuryVision = ImageAsset & {
  id: string;
  roofSystem: "metal" | "shingle" | "cedar" | "flat" | "mixed";
};

const SIZE = { width: 1536, height: 1024 } as const;

export const luxuryServiceVisions: readonly LuxuryVision[] = [
  {
    id: "west-vancouver-metal-blue-hour",
    src: "/media/luxury-service-visions/west-vancouver-metal-blue-hour.jpg",
    ...SIZE,
    roofSystem: "metal",
    alt: "Luxury West Vancouver hillside home with a charcoal standing-seam metal roof at blue hour",
  },
  {
    id: "shaughnessy-architectural-shingles",
    src: "/media/luxury-service-visions/shaughnessy-architectural-shingles.jpg",
    ...SIZE,
    roofSystem: "shingle",
    alt: "Luxury stone residence with a dimensional architectural shingle roof and copper detailing",
  },
  {
    id: "north-vancouver-cedar-estate",
    src: "/media/luxury-service-visions/north-vancouver-cedar-estate.jpg",
    ...SIZE,
    roofSystem: "cedar",
    alt: "Luxury North Vancouver forest residence with a warm cedar shake roof",
  },
  {
    id: "vancouver-penthouse-flat-roof",
    src: "/media/luxury-service-visions/vancouver-penthouse-flat-roof.jpg",
    ...SIZE,
    roofSystem: "flat",
    alt: "Luxury Vancouver penthouse building with a pristine low-slope membrane roof at sunset",
  },
  {
    id: "west-vancouver-waterfront-metal",
    src: "/media/luxury-service-visions/west-vancouver-waterfront-metal.jpg",
    ...SIZE,
    roofSystem: "metal",
    alt: "Waterfront luxury home with broad dark metal roof planes and refined eave details",
  },
  {
    id: "british-properties-shingle-estate",
    src: "/media/luxury-service-visions/british-properties-shingle-estate.jpg",
    ...SIZE,
    roofSystem: "shingle",
    alt: "British Properties luxury estate with a dark architectural shingle roof and copper flashing",
  },
  {
    id: "deep-cove-mixed-roof",
    src: "/media/luxury-service-visions/deep-cove-mixed-roof.jpg",
    ...SIZE,
    roofSystem: "mixed",
    alt: "Deep Cove luxury home combining standing-seam metal and low-slope membrane roofing",
  },
  {
    id: "langley-modern-farmhouse-metal",
    src: "/media/luxury-service-visions/langley-modern-farmhouse-metal.jpg",
    ...SIZE,
    roofSystem: "metal",
    alt: "Luxury Langley modern farmhouse with a crisp black standing-seam metal roof",
  },
  {
    id: "coal-harbour-penthouse-membrane",
    src: "/media/luxury-service-visions/coal-harbour-penthouse-membrane.jpg",
    ...SIZE,
    roofSystem: "flat",
    alt: "Coal Harbour luxury apartment residence with penthouses and a pristine membrane roof",
  },
  {
    id: "north-vancouver-luxury-craftsman",
    src: "/media/luxury-service-visions/north-vancouver-luxury-craftsman.jpg",
    ...SIZE,
    roofSystem: "shingle",
    alt: "Renovated North Vancouver luxury craftsman with a charcoal shingle roof and skylights",
  },
] as const;
